import Vue from 'vue'
//创建一个局部的vue实例
const eventbus = new Vue();
Vue.prototype.$eventbus = eventbus;

export default eventbus;
